import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Typography, Spin } from 'antd';
import { CheckCircle2, UserPlus, Server, MonitorSmartphone, LayoutTemplate } from 'lucide-react';

const { Title, Text } = Typography;

const steps = [
    { text: 'Authenticating your session...', icon: <UserPlus size={24} color="#60a5fa" /> },
    { text: 'Creating your Lite Brand Space...', icon: <Server size={24} color="#f472b6" /> },
    { text: 'Preparing display network constraints...', icon: <MonitorSmartphone size={24} color="#34d399" /> },
    { text: 'Setting up simple fullscreen Campaign...', icon: <LayoutTemplate size={24} color="#fbbf24" /> }
];

const SetupOverlay = () => {
    const [currentStep, setCurrentStep] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentStep((prev) => (prev < steps.length ? prev + 1 : prev));
        }, 800);
        return () => clearInterval(timer);
    }, []);

    return (
        <div style={{
            width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', background: '#ffffff'
        }}>
            <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ textAlign: 'center', padding: '60px' }}
            >
                <div style={{ marginBottom: '40px' }}>
                    <img src="/cms/assets/svgs/cdx_logo.svg" alt="PushCodex" style={{ height: 'auto', maxHeight: '48px', maxWidth: '100%', objectFit: 'contain', marginBottom: '16px' }} />
                    <Title level={4} style={{ color: '#1f2937', margin: 0 }}>Setting up your Lite Workspace</Title>
                    <Text type="secondary">This will just take a few seconds...</Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'flex-start', margin: '0 auto', maxWidth: '300px' }}>
                    {steps.map((step, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: currentStep >= index ? 1 : 0.3, x: 0 }}
                            transition={{ duration: 0.4 }}
                            style={{ display: 'flex', alignItems: 'center', gap: '16px', textAlign: 'left' }}
                        >
                            <div style={{ width: '24px', display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
                                {currentStep > index ? (
                                    <CheckCircle2 size={24} color="#10b981" />
                                ) : currentStep === index ? (
                                    <Spin indicator={step.icon} />
                                ) : (
                                    <div style={{ opacity: 0.5 }}>{step.icon}</div>
                                )}
                            </div>
                            <Text style={{ fontSize: '15px', color: currentStep >= index ? '#1f2937' : '#9ca3af', fontWeight: currentStep === index ? 600 : 400 }}>
                                {step.text}
                            </Text>
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </div>
    );
};

export default SetupOverlay;
